import React, { FC, useMemo, useState } from 'react';
import DataBox from '../DataBox';
import {
  V2MicrogridOverviewGetBsaTodayInfoPostResponse,
  V2MicrogridOverviewGetNewEnergyExistsPostResponse,
  V2MicrogridOverviewGetNewEnergyRatePostResponse,
} from '@maxtropy/intelligent-dispath-apis-v2';
import styles from './index.module.scss';
import icon_small_ground from '../../../../../imgs/icon-small-ground.png';
import icon_energyStorage from '../../../../../imgs/icon-energyStorage.png';
import { formatPower, judgeOverZero, keepTwoAbsOrLine, keepTwoOrLine } from '@/pages/IndustrialGreenMicBigScreen/utils';
import icon_pv from '../../../../../imgs/icon-PV.png';
import icon_windTurbine from '../../../../../imgs/icon-windTurbine.png';
import TwoAssetsRender from '../TwoAssetsRender';
import BsaDataBox from '../BsaDataBox';

type Energy = {
  [key: string]: boolean;
};

export interface IThreeAssetsRender {
  dataExit?: V2MicrogridOverviewGetNewEnergyExistsPostResponse;
  data?: V2MicrogridOverviewGetNewEnergyRatePostResponse;
}

const ThreeAssetsRender: FC<IThreeAssetsRender> = props => {
  const { dataExit, data } = props;
  const [bsaData, setBsaData] = useState<V2MicrogridOverviewGetBsaTodayInfoPostResponse>();

  const name = useMemo(() => {
    const obj: Energy = {
      光伏: dataExit?.pvExists ?? false,
      风电: dataExit?.wpExists ?? false,
    };
    const trueKeys = Object.keys(obj).filter(key => obj[key]);
    return trueKeys[0];
  }, [dataExit]);

  return (
    <>
      {/* 固定市电和负载 */}
      <TwoAssetsRender data={data} />

      {dataExit?.bsaExists ? (
        <>
          <BsaDataBox dataExit={dataExit} top={78} left={65} leftTitle="储" getBsaData={val => setBsaData(val)} />
          <div className={`${styles.element5} ${styles.element}`}>
            <div className={styles.power_box}>
              <div className={styles.power_label}>{judgeOverZero(bsaData?.power) ? '充电' : '放电'}功率：</div>
              <div className={styles.power_value}>{keepTwoAbsOrLine(bsaData?.power)}kW</div>
            </div>
            <img className={styles.img_obj_sty} src={icon_energyStorage} alt="" />
            <img className={`${styles.img_normal_sty} `} src={icon_small_ground} alt="" />
            <div className={styles.label}>储能</div>
          </div>
          {/* 流动的线5 */}
          <div className={`${styles.lineBg5} ${styles.lineBg_normal}`}>
            <div
              className={`${styles.line_inside_normal} ${styles.line5} ${
                styles[judgeOverZero(bsaData?.power) ? 'flow_up' : 'flow_down']
              }`}
            ></div>
          </div>
        </>
      ) : (
        <>
          <DataBox
            top={82}
            left={65}
            leftTitle={'源'}
            data={
              name === '光伏'
                ? [
                    {
                      label: '光伏容量',
                      value: keepTwoOrLine(data?.pvInfo?.capacity),
                      unit: 'kW',
                      color: 'rgba(255,255,255,0.85)',
                    },
                    {
                      label: '今日发电量',
                      value: formatPower(data?.pvInfo?.todayGeneration).value,
                      unit: formatPower(data?.pvInfo?.todayGeneration).unit,
                      color: '#16DD8E',
                    },
                  ]
                : [
                    {
                      label: '风电站容量',
                      value: keepTwoOrLine(data?.wpInfo?.capacity),
                      unit: 'kW',
                      color: 'rgba(255,255,255,0.85)',
                    },
                    {
                      label: '今日发电量',
                      value: formatPower(data?.wpInfo?.todayGeneration).value,
                      unit: formatPower(data?.wpInfo?.todayGeneration).unit,
                      color: '#16DD8E',
                    },
                  ]
            }
          />
          <div className={`${styles.element5} ${styles.element}`}>
            <div className={styles.power_box}>
              <div className={styles.power_label}>发电功率：</div>
              <div className={styles.power_value}>
                {name === '光伏'
                  ? keepTwoOrLine(data?.pvInfo?.generationPower)
                  : keepTwoOrLine(data?.wpInfo?.generationPower)}
                kW
              </div>
            </div>
            <img className={styles.img_obj_sty} src={name === '光伏' ? icon_pv : icon_windTurbine} alt="" />
            <img className={`${styles.img_normal_sty} `} src={icon_small_ground} alt="" />
            <div className={styles.label}>{name}</div>
          </div>
          {/* 流动的线5 */}
          <div className={`${styles.lineBg5} ${styles.lineBg_normal}`}>
            <div className={`${styles.line_inside_normal} ${styles.line5} ${styles.flow_down}`}></div>
          </div>
        </>
      )}
    </>
  );
};

export default ThreeAssetsRender;
